import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export const STAGE_STYLES = {
  RECEIVED: "bg-blue-50 text-[#008080] border-blue-200",
  VERIFICATION: "bg-amber-50 text-amber-800 border-amber-200",
  LOCATE_DATA: "bg-sky-50 text-sky-700 border-sky-200",
  REVIEW: "bg-indigo-50 text-indigo-700 border-indigo-200",
  RESPOND: "bg-purple-50 text-purple-700 border-purple-200",
  CLOSED: "bg-slate-200 text-slate-700 border-slate-300",
};

export const TYPE_STYLES = {
  ACCESS: "bg-[#003366] text-white",
  CORRECTION: "bg-teal-600 text-white",
  DELETION: "bg-red-600 text-white",
  NOMINEE: "bg-amber-500 text-white",
  GRIEVANCE: "bg-slate-600 text-white",
};

export const VERIFY_STYLES = {
  VERIFIED: "bg-emerald-50 text-emerald-700 border-emerald-200",
  FAILED: "bg-red-50 text-red-700 border-red-200",
  PENDING: "bg-slate-50 text-slate-600 border-slate-200",
};

export const ACTION_LABEL = {
  ACCESS: "Data extracted",
  CORRECTION: "Corrected",
  DELETION: "Deleted",
  NOMINEE: "Updated",
  GRIEVANCE: "Actioned",
};

export const slug = (s) => String(s).toLowerCase().replace(/[^a-z0-9]+/g, "-");

let metaCache = null;
export const useRightsMeta = () => {
  const [meta, setMeta] = useState(metaCache);
  const reload = useCallback(() => {
    api.get("/rights/meta").then(({ data }) => { metaCache = data; setMeta(data); }).catch(() => {});
  }, []);
  useEffect(() => { if (!metaCache) reload(); }, [reload]);
  return { meta, reload };
};

export const useDirectory = () => {
  const [users, setUsers] = useState([]);
  useEffect(() => {
    api.get("/platform/users/directory").then(({ data }) => setUsers(data.users)).catch(() => {});
  }, []);
  return users;
};

export const downloadEvidence = async (eid) => {
  const { data } = await api.post(`/v1/evidence/${eid}/signed-url`);
  window.open(`${process.env.REACT_APP_BACKEND_URL}${data.url}`, "_blank", "noopener");
};
